import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { SubArea, SubAreaCreateUpdate } from '#models';

@Injectable({
  providedIn: 'root',
})
export class SubAreaService {
  private _httpClient = inject(HttpClient);

  getByArea(areaId: number): Observable<SubArea[]> {
    return this._httpClient.get<SubArea[]>(`${environment.apiUrl}/sub-areas?areaId=${areaId}`);
  }

  create(payload: SubAreaCreateUpdate): Observable<SubArea> {
    return this._httpClient.post<SubArea>(`${environment.apiUrl}/sub-areas`, payload);
  }

  update(id: number, payload: SubAreaCreateUpdate): Observable<SubArea> {
    return this._httpClient.put<SubArea>(`${environment.apiUrl}/sub-areas/${id}`, payload);
  }

  delete(id: number): Observable<void> {
    return this._httpClient.delete<void>(`${environment.apiUrl}/sub-areas/${id}`);
  }
}
